module.exports = __webpack_public_path__ + "static/media/laser-depilation-for-who.0d077afc.md";